import { sections } from '../../constants'

const supportedSections = [sections.header, sections.hero, sections.body, sections.footer]

export default supportedSections
